import React from 'react';
import { useTranslation } from 'next-i18next';
import styles from './nav-tabs.module.scss';
import { combineCN } from '@helpers/styles.helper';
import { environment } from '@environment';

interface NavTab {
	id: string;
	labelKey: string;
	targetId: string;
	icon: string;
}

const InvestorsNavTabs = () => {
	const { t } = useTranslation();

	const tabs: NavTab[] = [
		{
			id: 'news',
			labelKey: 'IR_landing_news',
			targetId: 'investors-news',
			icon: `${environment.new_web_cdn_url}/new/investors/news.svg`
		},
		{
			id: 'governance',
			labelKey: 'investor_relation_corporate_governance',
			targetId: 'investors-governance',
			icon: `${environment.new_web_cdn_url}/new/investors/corporate-gov.svg`
		},
		{
			id: 'filings',
			labelKey: 'investor_relations_regulatory_filings',
			targetId: 'investors-filings',
			icon: `${environment.new_web_cdn_url}/new/investors/filings.svg`
		},
		{
			id: 'resources',
			labelKey: 'investor_relations_investor_resources',
			targetId: 'investors-resources',
			icon: `${environment.new_web_cdn_url}/new/investors/resources.svg`
		}
	];

	const scrollToSection = (targetId: string) => {
		const element = document.getElementById(targetId);
		if (element) {
			const yOffset = -100;
			const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
			window.scrollTo({ top: y, behavior: 'smooth' });
		}
	};

	return (
		<nav className={combineCN('d-flex f-column f-center w-100', styles.nav_wrapper)}>
			<div className={combineCN('d-flex f-justify-center', styles.nav_container)}>
				{tabs.map((tab) => (
					<button
						key={tab.id}
						type="button"
						className={combineCN('d-flex f-center', styles.nav_tab)}
						onClick={() => {
							scrollToSection(tab.targetId);
						}}
					>
						<img src={tab.icon} alt={tab.id} className={styles.tab_icon} />
						<span>{t(tab.labelKey)}</span>
					</button>
				))}
			</div>
		</nav>
	);
};

export default InvestorsNavTabs;
